import React from 'react';
import HtmlContent from '../../../../components-legacy/HtmlContent';
import { DesignerMediaWrapper, DesignerMedia } from '../../../../styled/Designer/wrappers';
import Distance from '../../../../styled/Distance';

interface IDesignerInformation {
  designer: IDesigner;
}

export default function DesignerInformation({ designer }: IDesignerInformation) {
  return (
    <>
      <HtmlContent markdown={designer.description} />
      <Distance size="3" line />

      <DesignerMediaWrapper>
        <DesignerMedia src={designer.portraitImage} />
      </DesignerMediaWrapper>
    </>
  );
}
